import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Inject } from '@angular/core';
import { MODAL_REF, ModalRef } from 'src/app/services/modal/modal-ref.token';

@Component({
    selector: 'app-caller-modal',
    templateUrl: './caller-modal.component.html',
    styleUrls: ['./caller-modal.component.scss'],
    standalone: false
})
export class CallerModalComponent implements OnInit, OnDestroy{
  @Input() callerName: string;
  @Input() calling = false;

  acceptState = false;
  noReplyTimer: any = null;
  constructor(@Inject(MODAL_REF) private modalRef: ModalRef) {}

  ngOnInit() {
    this.noReplyTimer = setTimeout(() => {
      if (!this.acceptState) {
        this.noReply();
      }
    }, 30000);
  }

  ngOnDestroy() {
    clearTimeout(this.noReplyTimer);
    this.noReplyTimer = null;
  }

  public acceptCall() {
    this.acceptState = true;
    this.modalRef.dismiss({
      acceptCall: 'accept',
    });
  }

  public cancelCall() {
    this.acceptState = true;
    this.modalRef.dismiss({
      acceptCall: 'cancel',
    });
  }

  public dismissModal() {
    this.acceptState = true;
    this.modalRef.dismiss();
  }

  private noReply() {
    this.modalRef.dismiss({
      acceptCall: 'no reply',
    });
  }
}
